import { PackageCreateEditController } from './packages-create-edit.directive.controller'

import { PackageService, PACKAGE_SERVICE_NAME } from '../../../services/package'
import { $SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../services/system'

import { CreateEditScope } from '../../common/common.create-edit.controller'

//#region Asset Imports

import * as TEMPLATE from './packages-create-edit.tpl.html'

//#endregion

// Setup

export class PackageCreateEditDirective implements ng.IDirective {

    restrict = 'E'

    controller = [$SCOPE_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, PACKAGE_SERVICE_NAME, (
        $scope: CreateEditScope,
        $q: ng.IQService,
        $timeout: ng.ITimeoutService,
        packageService: PackageService
    ) => new PackageCreateEditController(
        $scope,
        $q,
        $timeout,
        packageService,
        PackageService.REFERENCE_TYPE,
        PackageService.SIMAX_MODULE_NAME
    )]

    template = TEMPLATE
}

// Setup End